"use client";
import Link from "next/link";
import { ArrowRight, Target } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { goals as data } from "@/lib/data/mission";

const accents = ["var(--color-emerald)", "var(--color-cyan)", "var(--color-amber)", "var(--color-purple)"];

export function Goals() {
  return (
    <Section id="goals" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {data.goals.map((g, i) => {
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={g.goal} delay={i * 100}>
                <div className="relative h-full rounded-3xl glass p-7 overflow-hidden" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <div className="pointer-events-none absolute -top-12 -right-12 h-40 w-40 rounded-full opacity-15 blur-3xl" style={{ background: accent }} />
                  <div className="relative">
                    <div className="flex items-center gap-3">
                      <span className="grid place-items-center h-11 w-11 rounded-xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                        <Target className="h-5 w-5" style={{ color: accent }} />
                      </span>
                      <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{g.goal}</span>
                    </div>
                    <h3 className="mt-5">{g.title}</h3>
                    <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{g.body}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
